/* eslint-disable
    no-shadow,
    one-var
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import Backbone from 'backbone';
import React from 'react';
import ReactDOM from 'react-dom';
import _ from 'underscore';

import * as navigation from 'Navigation';
import notifications from 'notifications';
import {renderToDOM} from 'redux-stores/ReduxDOMRender';

import {performSignedFileQuery} from 'external-files/ExternalFileUtils';
import ExternalFilePreview from './ExternalFilePreview';
import ExternalFileOptions from './ExternalFileOptions';

class ExternalFileTabState extends navigation.TabState {
  defaults() {
    // eslint-disable-next-line no-restricted-syntax
    return _.extend(super.defaults(), {
      title: 'Preview',
      closeable: false,
      externalFile: null,
      printOptions: [],
      preferenceKey: 'external-file',
    });
  }

  externalFile() {
    return this.get('externalFile');
  }
  previewFile() {
    return this.get('previewFile');
  }
  printOptions() {
    return this.get('printOptions');
  }
  printHandler() {
    throw new Error('External files that are not entry protocols should not be printable');
  }
  updatePreviewType(previewType) {
    this.externalFile().save({previewType}, {patch: true}).fail(notifications.notifyError);
  }
}

class ExternalFileOptionsView extends Backbone.View {
  initialize() {
    this.listenTo(this.model.externalFile(), 'change:previewType change:url', this.render);
  }

  render() {
    let name, updateName;
    if (this.model.updateName != null) {
      name = this.model.get('title');
      updateName = (name) => {
        this.model.set({title: name});
        this.model.updateName(name);
      };
    } else {
      name = null;
      updateName = null;
    }
    renderToDOM(
      <ExternalFileOptions
        availablePreviewTypes={this.model.externalFile().availablePreviewTypes()}
        name={name}
        previewType={this.model.externalFile().previewType()}
        updateName={updateName}
        updatePreviewType={(previewType) => this.model.updatePreviewType(previewType)}
        generateDownloadUrl={async (isPreview) =>
          await performSignedFileQuery(
            this.model.externalFile().externalFileId(),
            this.model.externalFile().externalFileURL(),
            this.model.owningEntityApiId()
          )
        }
        printHandler={this.model.printHandler.bind(this.model)}
        printOptions={this.model.printOptions()}
        closeTab={() => {
          this.model.close();
        }}
      />,
      this.el
    );
    return this;
  }

  remove() {
    ReactDOM.unmountComponentAtNode(this.el);
    return super.remove();
  }
}

class ExternalFileTabView extends Backbone.View {
  static initClass() {
    this.prototype.className = 'external-file-wrapper buffer-tab buffer-tab--no-padding';
  }

  initialize() {
    this.listenTo(this.model.externalFile(), 'change:previewType change:url', this.render);
  }

  render() {
    let previewType, url, id;
    if (this.model.previewFile() != null) {
      ({url} = this.model.previewFile());
      ({id} = this.model.previewFile());
      ({previewType} = this.model.previewFile());
    } else {
      url = this.model.externalFile().externalFileURL();
      id = this.model.externalFile().externalFileId();
      previewType = this.model.externalFile().previewType();
    }
    const owningEntityApiId = this.model.owningEntityApiId();
    renderToDOM(
      <ExternalFilePreview
        url={url}
        externalFileId={id}
        previewType={previewType}
        owningEntityApiId={owningEntityApiId}
      />,
      this.el
    );
    return this;
  }

  remove() {
    ReactDOM.unmountComponentAtNode(this.el);
    return super.remove();
  }
}
ExternalFileTabView.initClass();

export {ExternalFileOptionsView, ExternalFileTabView, ExternalFileTabState};
